webpackJsonp([26,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mintUi = __webpack_require__(3);
	
	var _mintUi2 = _interopRequireDefault(_mintUi);
	
	__webpack_require__(7);
	
	__webpack_require__(14);
	
	__webpack_require__(13);
	
	__webpack_require__(31);
	
	__webpack_require__(15);
	
	__webpack_require__(270);
	
	var _hearMenu = __webpack_require__(16);
	
	var _hearMenu2 = _interopRequireDefault(_hearMenu);
	
	var _footerMeta = __webpack_require__(22);
	
	var _footerMeta2 = _interopRequireDefault(_footerMeta);
	
	var _pxToRem = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_mintUi2.default);
	
	new _vue2.default({
		el: '#app',
		data: {
			addVertical: '' },
		methods: {},
		mounted: function mounted() {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
			this.addVertical = isAndroid ? 'vertical-center' : '';
		},
	
		created: function created() {
			(0, _pxToRem.pxToRem)();
		},
		components: {
			hearMenu: _hearMenu2.default,
			footerMeta: _footerMeta2.default
		}
	});

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.common = undefined;
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mintUi = __webpack_require__(3);
	
	var _mintUi2 = _interopRequireDefault(_mintUi);
	
	var _jquery = __webpack_require__(8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _jqueryCookie = __webpack_require__(11);
	
	var _verification = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_mintUi2.default);
	
	var common = {
	  jumpSign: function jumpSign() {
	    window.location.href = "/user/sign.html";
	  },
	  subtractionNumber: function subtractionNumber(num1, num2) {
	    var sum = (Math.round(num1 * 100) - Math.round(num2 * 100)) / 100;
	    sum = this.toFixedNum(sum, 2);
	    return String(sum);
	  },
	  addNumber: function addNumber(num1, num2) {
	    var sum = (Math.round(num1 * 100) + Math.round(num2 * 100)) / 100;
	    sum = this.toFixedNum(sum, 2);
	    return String(sum);
	  },
	  toFixedNum: function toFixedNum(money, num) {
	    money = Number(money).toFixed(num);
	    return String(money);
	  },
	  ErrorMap: function ErrorMap(key, errpyMsg) {
	    var errorTips = {
	      CustomerLogicException: 'show',
	      InvalidArgumentException: '参数错误！',
	      TokenLogicException: 'tokenOver',
	      TaskStatusError: '很抱歉，系统繁忙，请稍后重试！',
	      RuntimeException: '很抱歉，系统繁忙，请稍后重试！',
	      LogicException: '很抱歉，系统繁忙，请稍后重试！'
	    };
	    var errorTip = errorTips[key];
	    _mintUi.Indicator.close();
	    if (errorTip == 'show') {
	      this.toastMsg(errpyMsg);
	    } else {
	      if (errorTip == 'tokenOver') {
	        window.location.href = "/user/sign.html";
	      } else {
	        this.toastMsg(errorTip);
	      }
	    }
	  },
	
	  isWeiXin: function isWeiXin() {
	    var ua = navigator.userAgent.toLowerCase();
	    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
	      var bo = true;
	      return bo;
	    } else {
	      var bo = false;
	      return bo;
	    }
	  },
	
	  getdataForTime: function getdataForTime(time) {
	    var Tomorrow = new Date(time);
	    var Tomorrowyear = Tomorrow.getFullYear();
	    var TomorrowMonth = Tomorrow.getMonth() + 1;
	    var TomorrowDay = Tomorrow.getDate();
	    var TomorrowDate = this.getParTime(TomorrowDay, TomorrowMonth, Tomorrowyear);
	    return TomorrowDate;
	  },
	
	  getParTime: function getParTime(newDay, newMonth, newYear) {
	    newDay = Number(newDay);
	    newMonth = Number(newMonth);
	    var data = '';
	    if (newMonth < 10 && newDay < 10) {
	      var data = newYear + '-0' + newMonth + '-0' + newDay;
	    } else if (newMonth >= 10 && newDay < 10) {
	      var data = newYear + '-' + newMonth + '-0' + newDay;
	    } else if (newMonth >= 10 && newDay >= 10) {
	      var data = newYear + '-' + newMonth + '-' + newDay;
	    } else if (newMonth < 10 && newDay >= 10) {
	      var data = newYear + '-0' + newMonth + '-' + newDay;
	    }
	    return data;
	  },
	  getNewMonthLostDay: function getNewMonthLostDay(newData) {
	    var data = newData.split(' ')[0];
	    return data;
	  },
	  getCurrentMonthLast: function getCurrentMonthLast(newData) {
	    var time = this.timeFitApple(newData);
	    var date = new Date(time);
	    var currentMonth = date.getMonth();
	    var nextMonth = ++currentMonth;
	    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
	    var oneDay = 1000 * 60 * 60 * 24;
	    return new Date(nextMonthFirstDay - oneDay);
	  },
	  timeFitApple: function timeFitApple(time) {
	    var desc = time.replace(/-/g, '/');
	    return desc;
	  },
	  getDateToObj: function getDateToObj(date) {
	    var reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
	    if (!reg.test(date)) {
	      return null;
	    }
	
	    var dateTimeArr = date.split(' ');
	    var dateArr = dateTimeArr[0].split('-');
	    var timeArr = dateTimeArr[1].split(':');
	    return {
	      year: dateArr[0],
	      month: dateArr[1],
	      day: dateArr[2],
	      hour: timeArr[0],
	      minute: timeArr[1],
	      second: timeArr[2]
	    };
	  },
	  postageParames: function postageParames(tex) {
	    if (!tex) {
	      return '';
	    }
	    var obj = {
	      '云主机': '云主机业务',
	      '云磁盘': '磁盘业务',
	      '云IP': 'IP业务',
	      '磁盘快照': '快照业务',
	      '带宽': '带宽业务,带宽包业务,VPC带宽业务',
	      'NAT网关': 'NAT业务',
	      'SLB负载均衡': 'slb业务',
	      'WEB应用防火墙': 'WAF业务',
	      '镜像服务': '镜像业务',
	      '购买': 'create',
	      '变更': 'adjust',
	      '续费': 'renew',
	      '销毁': 'destroy'
	    };
	    return obj[tex];
	  },
	  stationnewTypeParames: function stationnewTypeParames(tex) {
	    var obj = {
	      '全部类型': '',
	      '销毁提醒': 'destroy',
	      '到期提醒': 'expire',
	      '操作提醒': 'opt',
	      '财务消息': 'finance',
	      '安全消息': 'security',
	      '备案消息': 'record',
	      '监控消息': 'warning'
	    };
	    return obj[tex];
	  },
	  stationnewStateParames: function stationnewStateParames(tex) {
	    var obj = {
	      '全部状态': '',
	      '未读': '0',
	      '已读': '1'
	    };
	    return obj[tex];
	  },
	  isAndroid: function isAndroid() {
	    var u = navigator.userAgent;
	    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
	    var bo = isAndroid ? 'vertical-center' : '';
	    return bo;
	  },
	  regPasswdOne: function regPasswdOne(p1) {
	    if (!p1) {
	      this.toastMsg('请输入密码');
	      return false;
	    } else if (p1.length < 8 || p1.length > 32) {
	      this.toastMsg('密码长度不能超过32个位，不能少于6位');
	      return false;
	    } else if (!_verification.verification.passWord(p1)) {
	      this.toastMsg(' 密码为8-32位字符，至少包含(数字、大写字母、小写字母、特殊字符)中的3种字符。');
	      return false;
	    }
	    var regPass = /^[\S]{5,32}$/i;
	    if (!regPass.test(p1)) {
	      this.toastMsg('密码不能含有空白字符');
	      return false;
	    }
	    return true;
	  },
	  comfirm: function comfirm(object) {
	    (0, _mintUi.MessageBox)({
	      title: object.title,
	      message: object.message,
	      showCancelButton: true,
	      closeOnClickModal: false,
	      confirmButtonText: object.confirmButtonText ? object.confirmButtonText : '确定',
	      cancelButtonText: object.cancelButtonText ? object.cancelButtonText : '取消'
	    }).then(function (action) {
	      if (action === 'confirm') {
	        object.confirm();
	      } else {
	        object.cancel();
	      }
	    });
	  },
	
	  showTips: '',
	  toastMsg: function toastMsg(msg) {
	    if (this.showTips) {
	      this.showTips.close();
	    }
	    if (!msg) {
	      return;
	    }
	    this.showTips = (0, _mintUi.Toast)(msg);
	  },
	  showLoading: function showLoading(msg) {
	    _mintUi.Indicator.open(msg);
	  },
	  closeLoading: function closeLoading() {
	    _mintUi.Indicator.close();
	  },
	
	
	  toastSuccessMsg: function toastSuccessMsg(msg) {
	    if (this.showTips) {
	      this.showTips.close();
	    }
	    if (!msg) {
	      return;
	    }
	    this.showTips = (0, _mintUi.Toast)({
	      message: msg,
	      iconClass: 'iconfont icon-selected'
	    });
	    ;
	  },
	
	  getParforUrl: function getParforUrl(name) {
	    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	    var r = window.location.search.substr(1).match(reg);
	    if (r && r != null) return unescape(r[2]);
	    return null;
	  },
	  resetUrl: function resetUrl() {
	    var state = { title: '', url: location.href.split('?')[0] };
	    history.replaceState(state, '', state.url);
	  },
	
	  promotersIDCookies: function promotersIDCookies() {
	    var promotersID = this.getParforUrl('salesID');
	    if (promotersID) {
	      this.setCookies('promotersID', promotersID, 30);
	    }
	  },
	
	  setCookies: function setCookies(key, val, time) {
	
	    _jquery2.default.cookie(key, val, { expires: time, path: '/' });
	  },
	
	  getCookies: function getCookies(key) {
	    var desc = '';
	    desc = _jquery2.default.cookie(key);
	    return desc;
	  },
	
	  delete: function _delete(key) {
	
	    _jquery2.default.removeCookie(key, { path: '/' });
	    _jquery2.default.removeCookie(key, { path: '/', domain: window.location.host });
	  },
	
	  setSessionStorage: function setSessionStorage(key, value) {
	    sessionStorage.setItem(key, value);
	  },
	
	  getSessionStorage: function getSessionStorage(key) {
	    var desc = sessionStorage.getItem(key);
	    return desc;
	  },
	
	  deleteSessionStorage: function deleteSessionStorage(key) {
	    sessionStorage.removeItem(key);
	  },
	
	  judgeBaiduStatistics: function judgeBaiduStatistics() {
	    var href = window.location.href;
	    var host = window.location.host;
	    href = href.split('?')[0];
	    if (host == 'm.eflycloud.com') {
	      if (href === 'https://m.eflycloud.com/' || href === 'https://m.eflycloud.com') {
	        return true;
	      } else {
	        if (href.indexOf('other') !== -1 || href.indexOf('solve') !== -1 || href.indexOf('product') !== -1 || href.indexOf('data') !== -1 || href.indexOf('active') !== -1) {
	          return true;
	        } else {
	          return false;
	        }
	      }
	    } else {
	      return false;
	    }
	  },
	
	  getRealNameStatus: function getRealNameStatus(userInfo) {
	    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text';
	
	    var company = userInfo.companyVerifyStatus,
	        person = userInfo.realNameVerify;
	    var status = '',
	        color = '',
	        icon = '',
	        url = '';
	    switch (company) {
	      case 0:
	        {
	          switch (person) {
	            case 0:
	              {
	                status = '未实名认证';
	                break;
	              }
	            case -1:
	              {
	                status = '个人认证待审核';
	                break;
	              }
	            case -2:
	              {
	                status = '个人认证失败';
	                break;
	              }
	            case -3:
	              {
	                status = '个人认证审核中';
	                break;
	              }
	            case 1:
	              {
	                status = '个人认证成功';
	                break;
	              }
	          }
	          break;
	        }
	      case -1:
	        {
	          status = '企业认证失败';
	          break;
	        }
	      case -2:
	        {
	          status = '企业认证审核中';
	          break;
	        }
	      case -3:
	        {
	          status = '企业认证待审核';
	          break;
	        }
	      case 1:
	        {
	          status = '企业认证成功';
	          break;
	        }
	    }
	    switch (status) {
	      case '未实名认证':
	        {
	          color = 'text-muted';
	          icon = 'rj-icon-person';
	          url = "real-name-choose";
	          break;
	        }
	      case '个人认证待审核':
	        {
	          color = 'text-warming';
	          icon = 'rj-icon-person';
	          url = "real-name-tips";
	          break;
	        }
	      case '个人认证失败':
	        {
	          color = 'text-danger';
	          icon = 'rj-icon-person';
	          url = "real-name-write";
	          break;
	        }
	      case '个人认证审核中':
	        {
	          color = 'text-warming';
	          icon = 'rj-icon-person';
	          url = "real-name-tips";
	          break;
	        }
	      case '个人认证成功':
	        {
	          color = 'text-muted';
	          icon = 'text-success';
	          url = "real-name-success";
	          break;
	        }
	      case '企业认证失败':
	        {
	          color = 'text-danger';
	          icon = 'rj-icon-company-cirle';
	          url = "real-name-write";
	          break;
	        }
	      case '企业认证审核中':
	        {
	          color = 'text-warming';
	          icon = 'rj-icon-company-cirle';
	          url = "real-name-tips";
	          break;
	        }
	      case '企业认证待审核':
	        {
	          color = 'text-warming';
	          icon = 'rj-icon-company-cirle';
	          url = "real-name-tips";
	          break;
	        }
	      case '企业认证成功':
	        {
	          color = 'text-success';
	          icon = 'rj-icon-company-cirle';
	          url = "real-name-success";
	          break;
	        }
	    }
	    if (type === 'text') {
	      return status;
	    } else if (type === 'color') {
	      return color;
	    } else if (type === 'icon') {
	      return icon;
	    } else if (type === 'url') {
	      return url;
	    }
	  }
	};
	exports.common = common;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function pxToRem() {
	    var oHtml = document.getElementsByTagName("html")[0];
	    var oBody = document.getElementsByTagName("body")[0];
	    var psdsize = 750;
	    var htmlfont = oBody.offsetWidth / psdsize * 100 + 'px';
	    oHtml.style.fontSize = htmlfont;
	    oBody.style.opacity = '1';
	    window.onresize = function () {
	        var oHtml = document.getElementsByTagName("html")[0];
	        var oBody = document.getElementsByTagName("body")[0];
	        var psdsize = 750;
	        htmlfont = oBody.offsetWidth / psdsize * 100 + 'px';
	        oHtml.style.fontSize = htmlfont;
	    };
	
	    window.onload = function () {
	        var oApp = document.getElementById("load-img");
	        oApp.className = 'hide';
	    };
	}
	exports.pxToRem = pxToRem;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.service = undefined;
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(26);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(9);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _common = __webpack_require__(1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var service = {
	  getInterfaceUrl: function getInterfaceUrl() {
	    var host = window.location.host;
	
	    switch (host) {
	      case '192.168.10.42:8080':
	      case 'localhost:8080':
	      case '127.0.0.1:8080':
	        return 'https://testecf.eflycloud.com/ecfTask/';
	
	      case 'testmobile.eflycloud.com':
	        return 'https://testecf.eflycloud.com/ecfTask/';
	
	      case 'preonlinemobile.eflycloud.com':
	        return 'https://pre-ecf.eflycloud.com/ecfTask/';
	
	      case 'm.eflycloud.com':
	      default:
	        return 'https://ecf.eflycloud.com/ecfTask/';
	    }
	  },
	  getImgUrl: function getImgUrl() {
	    var host = window.location.host;
	
	    switch (host) {
	      case '192.168.10.42:8080':
	      case 'localhost:8080':
	      case '127.0.0.1:8080':
	        return 'https://testecf.eflycloud.com';
	
	      case 'testmobile.eflycloud.com':
	        return 'https://testecf.eflycloud.com';
	
	      case 'preonlinemobile.eflycloud.com':
	        return 'https://pre-ecf.eflycloud.com';
	
	      case 'm.eflycloud.com':
	      default:
	        return 'https://ecf.eflycloud.com';
	    }
	  },
	  getToken: function getToken(successFn, errorFn) {
	    var url = 'accountCenter/CreateToken';
	    var params = {
	      userID: 'RJ_VISITOR',
	      password: 'RJ_VISITOR'
	    };
	    this.interfaceUrl(url, params, '', successFn, errorFn);
	  },
	  arrangementPar: function arrangementPar(par, type) {
	
	    var params = {};
	    if (!par) {
	      return params;
	    }
	    for (var key in par) {
	      if (!par[key] && par[key] !== 0) {} else {
	        params[key] = par[key];
	      }
	    }
	    if (type == 'all') {
	      var __ecfToken = _common.common.getCookies('__ecfToken');
	      var userID = _common.common.getCookies('userID');
	      params['__ecfToken'] = __ecfToken;
	      params['userID'] = userID;
	    } else if (type == 'token') {
	      var _ecfToken = _common.common.getCookies('__ecfToken');
	      params['__ecfToken'] = _ecfToken;
	    }
	    return params;
	  },
	  interfaceUrl: function interfaceUrl(url, par, type, successFn, errorFn) {
	    var interfaceUrl = this.getInterfaceUrl() + url;
	    var params = this.arrangementPar(par, type);
	    var qs = __webpack_require__(9);
	    (0, _axios2.default)({
	      method: 'POST',
	      url: interfaceUrl,
	      headers: { 'content-type': 'application/x-www-form-urlencoded;charset=UTF-8' },
	      data: qs.stringify(params, { indices: false })
	    }).then(function (res) {
	      successFn(res.data);
	    }).catch(function (error) {
	      var errorTips = error.response.data;
	      if (!errorFn) {
	        _common.common.ErrorMap(errorTips.errorType, errorTips.errorMsg);
	      } else {
	        errorFn(errorTips);
	      }
	    });
	  }
	};
	
	exports.service = service;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var verification = {
	    sayHello: function sayHello() {
	        console.log('我是验证码');
	    },
	    passWord: function passWord(strPw) {
	        var reg = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z()`~!@#$%^&*\-_+=|{}\[\]:;'<>,.?\/\\]+$)(?![a-z\d]+$)(?![a-z()`~!@#$%^&*\-_+=|{}\[\]:;'<>,.?\/\\]+$)(?![\d()`~!@#$%^&*\-_+=|{}\[\]:;'<>,.?\/\\]+$)\S{8,32}$/g;
	        return reg.test(strPw);
	    },
	    isMobile: function isMobile(mobile) {
	        var reg = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
	        return reg.test(mobile);
	    },
	    mobileCode: function mobileCode(number) {
	        number = this.trimStr(number);
	        var reg = /^\d{4,6}$/;
	        return reg.test(number);
	    },
	    trimStr: function trimStr(str) {
	        return str.replace(/(^\s*)|(\s*$)/g, "");
	    },
	    isTrueName: function isTrueName(name) {
	        var reg = /^[\u4E00-\u9FA5]+$/;
	        return reg.test(name);
	    },
	    isComName: function isComName(companyName) {
	        var reg = /^[a-zA-Z0-9\u4E00-\u9FA5\(\)\（\）\s]+$/;
	        return reg.test(companyName);
	    },
	    isCompanyCode: function isCompanyCode(companyCode) {
	        return this.isOrgCode(companyCode) || this.isSocialCreditCode(companyCode);
	    },
	    isOrgCode: function isOrgCode(value) {
	        if (value != '') {
	            var values = value.split('-');
	            var ws = [3, 7, 9, 10, 5, 8, 4, 2];
	            var str = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	            var reg = /^([0-9A-Z]){8}-[0-9|X]$/;
	            if (!reg.test(value)) {
	                return false;
	            }
	            var sum = 0;
	            for (var i = 0; i < 8; i++) {
	                sum += str.indexOf(values[0].charAt(i)) * ws[i];
	            }
	            var C9 = 11 - sum % 11 + '';
	            var YC9 = values[1] + '';
	            if (C9 == '11') {
	                C9 = '0';
	            } else if (C9 == '10') {
	                C9 = 'X';
	            } else {
	                C9 = C9 + '';
	            }
	            return YC9 == C9;
	        }
	    },
	    isSocialCreditCode: function isSocialCreditCode(Code) {
	        var regName = /^(11|12|13|19|51|52|53|59|91|92|93|Y1)\d{6}[0-9A-Z]{10}$/;
	        if (Code.length !== 18 || !regName.test(Code)) {
	            return false;
	        }
	        var orgCode = Code.substring(8, 16) + '-' + Code.substring(16, 17);
	        if (!this.isOrgCode(orgCode)) {
	            return false;
	        }
	        var ws = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];
	        var str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
	        var sum = 0;
	        for (var i = 0; i < 17; i++) {
	            sum += str.indexOf(Code.charAt(i)) * ws[i];
	        }
	        var C18 = 31 - sum % 31;
	        if (C18 === 31) {
	            C18 = 0;
	        }
	        var C18_str = str.substring(C18, C18 + 1);
	        var YC18 = Code.substring(17, 18);
	        return YC18 === C18_str;
	    },
	    isEmail: function isEmail(strEmail) {
	        if (!strEmail || strEmail == '') {
	            return false;
	        }
	        if (strEmail.search(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/) != -1) {
	            return true;
	        } else {
	            return false;
	        }
	    },
	    isCode: function isCode(number) {
	        var reg = /^\d{4,6}$/;
	        return reg.test(number);
	    }
	};
	exports.verification = verification;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _keys = __webpack_require__(24);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _common = __webpack_require__(1);
	
	var _service = __webpack_require__(5);
	
	var _pxToRem = __webpack_require__(4);
	
	var _mintUi = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		props: {
			subscribe: {
				type: Boolean,
				default: true
			}
		},
		data: function data() {
			return {
				menuBg: '',
				showBgPage: ['/module/index.html', '/', 'product', 'solve', 'data', '/other/cooperation.html'],
				addVertical: '',
				hearMenuMessage: false,
				customerInfo: {},
	
				message: 0,
	
				hearMenuDoc: false,
				secondShow: {
					productSecondShow: false,
					dataSecondShow: false,
					solveSecondShow: false
				},
				productSecondData: [{ title: '云服务器', hrefName: '/product/cloud.html' }, { title: '云磁盘存储', hrefName: '/product/disk.html' }, { title: '云快照备份', hrefName: '/product/snapshot.html' }, { title: '镜像服务', hrefName: '/product/mirror.html' }, { title: 'VPC虚拟私有云', hrefName: '/product/vpc.html' }, { title: '弹性公网IP', hrefName: '/product/eip.html' }, { title: 'NAT网关', hrefName: '/product/nat.html' }, { title: '共享带宽包', hrefName: '/product/shareband.html' }, { title: 'SLB负载均衡', hrefName: '/product/slb.html' }, { title: '智能云解析', hrefName: '/product/dns.html' }, { title: '云高防', hrefName: '/product/safe.html' }, { title: 'IDC服务器托管', hrefName: '/product/idc.html' }, { title: 'IDC服务器租赁', hrefName: '/product/idcLease.html' }, { title: 'BGP网络接入', hrefName: '/product/bgp.html' }, { title: '大带宽接入', hrefName: '/product/bandwidth.html' }, { title: '专属云', hrefName: '/product/exclusive.html' }, { title: '私有云', hrefName: '/product/private.html' }],
				solveSecondData: [{ title: '电商解决方案', hrefName: '/solve/commerce.html' }, { title: '游戏解决方案', hrefName: '/solve/game.html' }, { title: 'APP解决方案', hrefName: '/solve/app.html' }, { title: '视频解决方案', hrefName: '/solve/video.html' }, { title: '网站解决方案', hrefName: '/solve/web.html' }, { title: '政企解决方案', hrefName: '/solve/government.html' }, { title: '容灾双活解决方案', hrefName: '/solve/recovery.html' }, { title: '教育解决方案', hrefName: '/solve/education.html' }, { title: '数据管控解决方案', hrefName: '/solve/data-control.html' }, { title: '行为管控解决方案', hrefName: '/solve/behavior-control.html' }, { title: 'IT成本优化解决方案', hrefName: '/solve/it-cost.html' }, { title: 'IT架构融合解决方案', hrefName: '/solve/it-architecture-fusion.html' }, { title: '视频渲染解决方案', hrefName: '/solve/video-renderer.html' }, { title: '超融合灾备解决方案', hrefName: '/solve/hyper-converged-dr.html' }],
				dataSecondData: [{ title: '华南地区', hrefName: '/data/huaNan.html' }, { title: '华东地区', hrefName: '/data/huaDong.html' }, { title: '华北地区', hrefName: '/data/huaBei.html' }],
				props: {
					isSubscribe: String
				},
				handler: function handler(e) {
					e.preventDefault();
				}
			};
		},
	
		methods: {
			judgeTopBg: function judgeTopBg(scrollTop) {
				if (scrollTop != 0) {
					this.menuBg = 'menu-bg-show';
				} else {
					this.menuBg = '';
				}
				if (this.pageIndex < 0) {
					this.menuBg = 'menu-bg-show';
					return;
				}
			},
			judgeTopBgCreate: function judgeTopBgCreate() {
				var urlPath = window.location.pathname;
				this.pageIndex = this.showBgPage.indexOf(urlPath);
	
				var urlArr = urlPath.split("/");
				if (urlArr.length > 1 && this.pageIndex < 0) {
					this.pageIndex = this.showBgPage.indexOf(urlArr[1]);
				}
	
				if (!urlPath) {
					this.pageIndex = 1;
				}
				this.judgeTopBg(0);
			},
			changeUserOperation: function changeUserOperation() {
				this.hearMenuMessage = true;
				this.judgeTopBg(100);
			},
			changeUserDoc: function changeUserDoc() {
				this.hearMenuDoc = true;
				this.judgeTopBg(100);
				this.dataScondSwitch('tex');
			},
			hideUserDoc: function hideUserDoc() {
				this.hearMenuDoc = false;
			},
			dataScondSwitch: function dataScondSwitch(tex) {
				var secondShow = this.secondShow;
				(0, _keys2.default)(secondShow).forEach(function (key) {
					secondShow[key] = key == tex ? !secondShow[key] : false;
				});
				this.secondShow = secondShow;
			},
	
	
			setFree: function setFree() {
				if (window.location.pathname === '/active/free.html') {
					_common.common.setCookies('jump', '/active/free.html', 7);
				}
			},
	
			getUserMessage: function getUserMessage() {
				var interfaceName = 'cloudPlatform/QueryCustomerInfo';
				_service.service.interfaceUrl(interfaceName, {}, 'all', this.getUserMessageSuccess, this.getUserMessageError);
			},
			getUserMessageSuccess: function getUserMessageSuccess(res) {
				this.customerInfo = res.data;
				this.getUserMoney();
				this.getMessage();
	
				_common.common.setCookies('email', this.customerInfo.email, 7);
			},
			getUserMessageError: function getUserMessageError(res) {
				this.customerInfo = {};
			},
			getUserMoney: function getUserMoney() {
				var interfaceName = 'cloudPlatform/GetUserBalance';
				_service.service.interfaceUrl(interfaceName, {}, 'all', this.getUserMoneySuccess, this.getUserMoneySuccess);
			},
			getUserMoneySuccess: function getUserMoneySuccess(res) {
				if (res && res.data) {
					this.customerInfo.money = _common.common.addNumber(res.data.cashMoney, res.data.couponMoney);
				}
			},
			getMessage: function getMessage() {
				var interfaceName = 'message/QueryMessageByMultipleParam';
				var param = {
					limitStart: 0,
					limitCount: 4,
					isread: 0
				};
				_service.service.interfaceUrl(interfaceName, param, 'all', this.getMessageSuccess);
			},
			getMessageSuccess: function getMessageSuccess(res) {
				this.message = res.data.count;
			},
			unSign: function unSign() {
				var interfaceName = 'cloudPlatform/Logout';
				var token = _common.common.getCookies('__ecfToken');
				var parameter = {
					tokenUUID: token
				};
				_service.service.interfaceUrl(interfaceName, parameter, 'all', this.unSignSuccess);
			},
			unSignSuccess: function unSignSuccess() {
				_common.common.delete('__ecfToken');
				_common.common.delete('userID');
				this.goToSign();
			},
			goToSign: function goToSign() {
				_common.common.jumpSign();
			},
			getFromPar: function getFromPar() {
				var from = _common.common.getParforUrl('from');
				if (from) {
					_common.common.setCookies('from', from);
				}
			},
			getSourceUrl: function getSourceUrl() {
				var sourceUrl = _common.common.getParforUrl('sourceUrl');
				var lostUrl = sourceUrl || document.referrer;
				var nowUrl = window.location.host;
				if (!!lostUrl && lostUrl.indexOf(nowUrl) === -1 && lostUrl.indexOf('eflycloud') === -1) {
					_common.common.setCookies('sourceUrl', lostUrl, 30);
				}
			},
			windowScroll: function windowScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				this.judgeTopBg(scrollTop);
			},
	
			closeTouch: function closeTouch() {
				document.getElementsByTagName("body")[0].addEventListener('touchmove', this.handler, { passive: false });
			},
			openTouch: function openTouch() {
				var oThis = this;
				document.getElementsByTagName("body")[0].removeEventListener('touchmove', this.handler, { passive: true });
			}
		},
		mounted: function mounted() {
			window.addEventListener('scroll', this.windowScroll);
	
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
			this.addVertical = isAndroid ? 'vertical-center' : '';
		},
	
		beforeCreate: function beforeCreate() {
			(0, _pxToRem.pxToRem)();
			if (_common.common.judgeBaiduStatistics()) {
				if (window.location.host == 'm.eflycloud.com') {
					var _hmt = _hmt || [];
					(function () {
						var hm = document.createElement("script");
						hm.src = "https://hm.baidu.com/hm.js?3dfbd11546977320370cd51be7c3a56e";
						var s = document.getElementsByTagName("script")[0];
						s.parentNode.insertBefore(hm, s);
					})();
				}
	
				if (window.location.host == 'm.eflycloud.com') {
					window._agl = window._agl || [];
					(function () {
						_agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD']);
						(function () {
							var agl = document.createElement('script');
							agl.type = 'text/javascript';
							agl.async = true;
							agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
							var s = document.getElementsByTagName('script')[0];
							s.parentNode.insertBefore(agl, s);
						})();
					})();
				}
	
				if (window.location.host === 'm.eflycloud.com') {
					var _hmt = _hmt || [];
					var hm = document.createElement("script");
					hm.src = "https://hm.baidu.com/hm.js?dbb161b0ac3a4d9e49fe7aa9d5689ea7";
					var s = document.getElementsByTagName("script")[0];
					s.parentNode.insertBefore(hm, s);
				}
			}
		},
		created: function created() {
			var isLogin = _common.common.getCookies('userID');
			if (isLogin && isLogin != 'RJ_VISITOR') {
				this.customerInfo.userID = isLogin;
				this.getUserMessage();
			}
			this.judgeTopBgCreate();
			_common.common.promotersIDCookies();
			this.getFromPar();
			this.getSourceUrl();
		},
		watch: {
			hearMenuMessage: function hearMenuMessage(val) {
				if (val) {
					this.closeTouch();
				} else {
					this.openTouch();
				}
			},
	
			hearMenuDoc: function hearMenuDoc(val) {
				this.openTouch();
			}
		},
		computed: {}
	};

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _stringify = __webpack_require__(27);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(25);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (factory) {
	    if ("function" === 'function' && __webpack_require__(28).cmd) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	            return function (jQuery) {
	                factory(jQuery);
	            };
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (( false ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') {
	        factory(__webpack_require__(8));
	    } else {
	        factory(jQuery);
	    }
	})(function ($) {
	
	    var pluses = /\+/g;
	
	    function encode(s) {
	        return config.raw ? s : encodeURIComponent(s);
	    }
	
	    function decode(s) {
	        return config.raw ? s : decodeURIComponent(s);
	    }
	
	    function stringifyCookieValue(value) {
	        return encode(config.json ? (0, _stringify2.default)(value) : String(value));
	    }
	
	    function parseCookieValue(s) {
	        if (s.indexOf('"') === 0) {
	            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
	        }
	
	        try {
	            s = decodeURIComponent(s.replace(pluses, ' '));
	            return config.json ? JSON.parse(s) : s;
	        } catch (e) {}
	    }
	
	    function read(s, converter) {
	        var value = config.raw ? s : parseCookieValue(s);
	        return $.isFunction(converter) ? converter(value) : value;
	    }
	
	    var config = $.cookie = function (key, value, options) {
	
	        if (value !== undefined && !$.isFunction(value)) {
	            options = $.extend({}, config.defaults, options);
	
	            if (typeof options.expires === 'number') {
	                var days = options.expires,
	                    t = options.expires = new Date();
	                t.setTime(+t + days * 864e+5);
	            }
	
	            return document.cookie = [encode(key), '=', stringifyCookieValue(value), options.expires ? '; expires=' + options.expires.toUTCString() : '', options.path ? '; path=' + options.path : '', options.domain ? '; domain=' + options.domain : '', options.secure ? '; secure' : ''].join('');
	        }
	
	        var result = key ? undefined : {};
	
	        var cookies = document.cookie ? document.cookie.split('; ') : [];
	
	        for (var i = 0, l = cookies.length; i < l; i++) {
	            var parts = cookies[i].split('=');
	            var name = decode(parts.shift());
	            var cookie = parts.join('=');
	
	            if (key && key === name) {
	                result = read(cookie, value);
	                break;
	            }
	
	            if (!key && (cookie = read(cookie)) !== undefined) {
	                result[name] = cookie;
	            }
	        }
	
	        return result;
	    };
	
	    config.defaults = {};
	
	    $.removeCookie = function (key, options) {
	        if ($.cookie(key) === undefined) {
	            return false;
	        }
	
	        $.cookie(key, '', $.extend({}, options, { expires: -1 }));
	        return !$.cookie(key);
	    };
	});

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(12)
	
	/* script */
	__vue_exports__ = __webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(17)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hear-menu-main"
	  }, [_c('ul', {
	    staticClass: "hear-menu-warp box",
	    class: [_vm.menuBg, _vm.addVertical]
	  }, [_vm._m(0), _vm._v(" "), (_vm.subscribe) ? _c('li', {
	    staticClass: "box menu-right"
	  }, [_c('div', {
	    staticClass: "sign-warp relative sign-warp-btn-hide",
	    class: {
	      'show': !_vm.customerInfo.userID
	    }
	  }, [_c('span', {
	    staticClass: "sign-btn"
	  }, [_c('a', {
	    class: [_vm.addVertical],
	    attrs: {
	      "href": "/user/sign.html"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setFree()
	      }
	    }
	  }, [_vm._v("登录")]), _vm._v(" "), _c('a', {
	    staticClass: "sign-btn-warming",
	    class: [_vm.addVertical],
	    attrs: {
	      "href": "/user/register.html"
	    }
	  }, [_vm._v("注册")])])]), _vm._v(" "), _c('div', {
	    staticClass: "sign-warp sign-warp-btn-hide",
	    class: {
	      'show': _vm.customerInfo.userID
	    },
	    on: {
	      "click": function($event) {
	        _vm.changeUserOperation()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "sign-btn-admin",
	    class: [_vm.addVertical]
	  }, [_vm._v("管理")])]), _vm._v(" "), _c('div', {
	    staticClass: "sign-warp sign-warp-menu-btn",
	    on: {
	      "click": function($event) {
	        _vm.changeUserDoc()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "iconfont icon-menu icon-menu-css"
	  }), _vm._v(" 菜单\n\t\t\t")])]) : _vm._e()]), _vm._v(" "), _c('mt-popup', {
	    attrs: {
	      "position": "right"
	    },
	    model: {
	      value: (_vm.hearMenuMessage),
	      callback: function($$v) {
	        _vm.hearMenuMessage = $$v
	      },
	      expression: "hearMenuMessage"
	    }
	  }, [_c('div', {
	    staticClass: "child-menu flex",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('ul', {
	    staticClass: "user-warp"
	  }, [_c('li', {
	    staticClass: "user-img relative"
	  }, [_c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/message.html"
	    }
	  })]), _vm._v(" "), _c('li', {
	    class: {
	      'hide': !_vm.customerInfo.userID
	    }
	  }, [_c('ul', [_c('li', {
	    staticClass: "user-status btn-outline-warming",
	    class: {
	      'hide': _vm.customerInfo.level != 'silver'
	    }
	  }, [_vm._v("普通会员")]), _vm._v(" "), _c('li', {
	    staticClass: "user-status btn-outline-deep-warming",
	    class: {
	      'hide': _vm.customerInfo.level != 'gold'
	    }
	  }, [_vm._v("VIP客户")]), _vm._v(" "), _c('li', {
	    staticClass: "user-status btn-outline-primary",
	    class: {
	      'hide': _vm.customerInfo.level != 'civilian'
	    }
	  }, [_vm._v("推广专员")]), _vm._v(" "), _c('li', {
	    staticClass: "user-status btn-outline-success",
	    class: {
	      'hide': _vm.customerInfo.level != 'bronze'
	    }
	  }, [_vm._v("渠道代理")]), _vm._v(" "), _c('li', {
	    staticClass: "user-name"
	  }, [_vm._v(_vm._s(_vm.customerInfo.email))]), _vm._v(" "), _c('li', {
	    staticClass: "text-success",
	    class: {
	      'hide': _vm.customerInfo.realNameVerify !== 1
	    }
	  }, [_c('i', {
	    staticClass: "iconfont icon-success"
	  }), _vm._v(" 已实名认证\n\t\t\t\t\t\t")]), _vm._v(" "), _c('li', {
	    staticClass: "text-deep-warming",
	    class: {
	      'hide': _vm.customerInfo.realNameVerify === 1
	    }
	  }, [_c('i', {
	    staticClass: "iconfont"
	  }), _vm._v(" 未实名认证\n\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('ul', {
	    staticClass: "user-title-warp box"
	  }, [_c('li', [_vm._v("\n\t\t\t\t\t余额："), _c('span', {
	    staticClass: "user-money text-deep-warming"
	  }, [_vm._v("￥" + _vm._s(_vm.customerInfo.money))])]), _vm._v(" "), _c('li', {
	    staticClass: "btn btn-deep-warming relative",
	    class: [_vm.addVertical]
	  }, [_vm._v("\n\t\t\t\t\t充值\n\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/recharge.html"
	    }
	  })])]), _vm._v(" "), _c('ul', {
	    staticClass: "user-operation-warp box"
	  }, [_c('li', {
	    staticClass: "user-operation-item flex"
	  }, [_c('div', [_c('i', {
	    staticClass: "iconfont icon-moneyrecord user-operation-infont"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "user-operation-title relative"
	  }, [_vm._v("\n\t\t\t\t\t\t资金记录\n\t\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/capital.html"
	    }
	  })])]), _vm._v(" "), _c('li', {
	    staticClass: "user-operation-item flex"
	  }, [_c('div', [_c('i', {
	    staticClass: "iconfont icon-daijinquan user-operation-infont"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "user-operation-title relative"
	  }, [_vm._v("\n\t\t\t\t\t\t代金券管理\n\t\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/coupon.html"
	    }
	  })])])]), _vm._v(" "), _c('ul', {
	    staticClass: "user-operation-warp box"
	  }, [_c('li', {
	    staticClass: "user-operation-item flex"
	  }, [_c('div', [_c('i', {
	    staticClass: "iconfont icon-zifei user-operation-infont"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "user-operation-title relative"
	  }, [_vm._v("\n\t\t\t\t\t\t资费记录\n\t\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/postage.html"
	    }
	  })])]), _vm._v(" "), _c('li', {
	    staticClass: "user-operation-item flex"
	  }, [_c('div', [_c('i', {
	    staticClass: "iconfont icon-yajin user-operation-infont"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "user-operation-title relative"
	  }, [_vm._v("\n\t\t\t\t\t\t押金记录\n\t\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/deposit.html"
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "user-title-warp other-top"
	  }, [_vm._v("\n\t\t\t\t其他服务\n\t\t\t")]), _vm._v(" "), _c('ul', {
	    staticClass: "user-operation-warp box"
	  }, [_c('li', {
	    staticClass: "user-operation-item flex"
	  }, [_c('div', [_c('i', {
	    staticClass: "iconfont icon-config user-operation-infont"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "user-operation-title relative"
	  }, [_vm._v("\n\t\t\t\t\t\t资源管理\n\t\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/resources.html"
	    }
	  })])]), _vm._v(" "), _c('li', {
	    staticClass: "user-operation-item flex relative"
	  }, [_c('div', [_c('i', {
	    staticClass: "iconfont icon-info1 user-operation-infont"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "user-operation-title relative"
	  }, [_vm._v("\n\t\t\t\t\t\t站内消息\n\t\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/stationnew.html"
	    }
	  })]), _vm._v(" "), (_vm.message > 0) ? _c('div', {
	    staticClass: "user-msg"
	  }, [_vm._v(_vm._s(_vm.message > 99 ? '99+' : _vm.message))]) : _vm._e()])]), _vm._v(" "), _c('ul', {
	    staticClass: "user-title-warp box menu-footer-warp"
	  }, [_c('li', {
	    staticClass: "flex footer-item footer-item-left relative"
	  }, [_c('i', {
	    staticClass: "iconfont icon-home"
	  }), _vm._v(" 首页\n\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/"
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "flex footer-item footer-item-right",
	    on: {
	      "click": function($event) {
	        _vm.unSign()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "iconfont icon-signOut"
	  }), _vm._v(" 退出登录\n\t\t\t\t")])])])]), _vm._v(" "), _c('mt-popup', {
	    attrs: {
	      "id": "menu-doc",
	      "position": "right"
	    },
	    model: {
	      value: (_vm.hearMenuDoc),
	      callback: function($$v) {
	        _vm.hearMenuDoc = $$v
	      },
	      expression: "hearMenuDoc"
	    }
	  }, [_c('ul', {
	    staticClass: "child-menu flex"
	  }, [_c('li', {
	    staticClass: "user-title-warp title-close-warp",
	    on: {
	      "click": function($event) {
	        _vm.hideUserDoc()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "iconfont icon-error"
	  }), _vm._v(" 关闭\n\t\t\t")]), _vm._v(" "), _c('li', {
	    staticClass: "title-main"
	  }, [_c('ul', [_c('li', {
	    staticClass: "user-title-warp"
	  }, [_c('i', {
	    staticClass: "iconfont icon-home"
	  }), _vm._v(" 首页\n\t\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/"
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "user-title-warp box",
	    on: {
	      "click": function($event) {
	        _vm.dataScondSwitch('productSecondShow')
	      }
	    }
	  }, [_c('div', [_c('i', {
	    staticClass: "iconfont icon-server"
	  }), _vm._v(" 产品与服务")]), _vm._v(" "), _c('i', {
	    staticClass: "iconfont",
	    class: {
	      'icon-right': !_vm.secondShow.productSecondShow, 'icon-dowm': _vm.secondShow.productSecondShow
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "user-second-warp box product-second-warp",
	    class: {
	      'hide-second': !_vm.secondShow.productSecondShow
	    }
	  }, _vm._l((_vm.productSecondData), function(item) {
	    return _c('div', {
	      staticClass: "user-second-item btn relative"
	    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t\t"), _c('a', {
	      staticClass: "jump-warp",
	      attrs: {
	        "href": item.hrefName
	      }
	    })])
	  }), 0), _vm._v(" "), _c('li', {
	    staticClass: "user-title-warp box",
	    on: {
	      "click": function($event) {
	        _vm.dataScondSwitch('solveSecondShow')
	      }
	    }
	  }, [_c('div', [_c('i', {
	    staticClass: "iconfont icon-solution"
	  }), _vm._v(" 解决方案")]), _vm._v(" "), _c('i', {
	    staticClass: "iconfont",
	    class: {
	      'icon-right': !_vm.secondShow.solveSecondShow, 'icon-dowm': _vm.secondShow.solveSecondShow
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "user-second-warp box solve-second-warp",
	    class: {
	      'hide-second': !_vm.secondShow.solveSecondShow
	    }
	  }, _vm._l((_vm.solveSecondData), function(item) {
	    return _c('div', {
	      staticClass: "user-second-item btn relative"
	    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t\t"), _c('a', {
	      staticClass: "jump-warp",
	      attrs: {
	        "href": item.hrefName
	      }
	    })])
	  }), 0), _vm._v(" "), _c('li', {
	    staticClass: "user-title-warp box",
	    on: {
	      "click": function($event) {
	        _vm.dataScondSwitch('dataSecondShow')
	      }
	    }
	  }, [_c('div', [_c('i', {
	    staticClass: "iconfont icon-datacenter"
	  }), _vm._v(" 云数据中心\n\t\t\t\t\t\t")]), _vm._v(" "), _c('i', {
	    staticClass: "iconfont",
	    class: {
	      'icon-right': !_vm.secondShow.dataSecondShow, 'icon-dowm': _vm.secondShow.dataSecondShow
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "user-second-warp box",
	    class: {
	      'hide-second': !_vm.secondShow.dataSecondShow
	    }
	  }, _vm._l((_vm.dataSecondData), function(item) {
	    return _c('div', {
	      staticClass: "user-second-item btn relative"
	    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t\t"), _c('a', {
	      staticClass: "jump-warp",
	      attrs: {
	        "href": item.hrefName
	      }
	    })])
	  }), 0), _vm._v(" "), _c('li', {
	    staticClass: "user-title-warp"
	  }, [_c('i', {
	    staticClass: "iconfont icon-about1"
	  }), _vm._v(" 关于睿江云\n\t\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/other/aboutUs.html"
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "doc-footer-warp",
	    class: {
	      'hide': _vm.customerInfo.userID
	    }
	  }, [_c('div', {
	    staticClass: "user-title-register btn-primary"
	  }, [_vm._v("\n\t\t\t\t\t\t\t登录\n\t\t\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/sign.html"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "user-title-register sign-btn-warming"
	  }, [_vm._v("\n\t\t\t\t\t\t\t免费注册会员\n\t\t\t\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/register.html"
	    }
	  })])])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "box menu-left relative"
	  }, [_c('div', {
	    staticClass: "menu-logo"
	  }), _vm._v(" "), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/"
	    }
	  })])
	}]}

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _common = __webpack_require__(1);
	
	exports.default = {
		data: function data() {
			return {
				suspensionShow: '',
				addVertical: ''
			};
		},
	
		methods: {
			setSuspensionShow: function setSuspensionShow() {
				this.suspensionShow = _common.common.getSessionStorage('suspensionShow');
				if (this.suspensionShow !== 'hidden') {
					this.suspensionShow = true;
				} else {
					this.suspensionShow = false;
				}
				console.log(this.suspensionShow);
			},
			closeSuspension: function closeSuspension() {
				this.suspensionShow = false;
				_common.common.setSessionStorage('suspensionShow', 'hidden');
			}
		},
		mounted: function mounted() {
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
			this.addVertical = isAndroid ? 'vertical-center' : '';
		},
	
		created: function created() {
			this.setSuspensionShow();
		}
	};

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/code.fcf651c.png";

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/tel.44d8585.png";

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(19)
	
	/* script */
	__vue_exports__ = __webpack_require__(18)
	
	/* template */
	var __vue_template__ = __webpack_require__(23)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer-meta"
	  }, [_c('div', {
	    staticClass: "jump-rj-warp"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "jump-rj-btn relative",
	    class: [_vm.addVertical]
	  }, [_vm._v("\n\t\t\t进入睿江云小程序\n\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/resources.html"
	    }
	  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "footer-suspension-main",
	    class: {
	      'hide': !_vm.suspensionShow
	    }
	  }, [_c('div', {
	    staticClass: "footer-suspension-warp box"
	  }, [_c('div', {
	    staticClass: "box footer-suspension-left"
	  }, [_c('i', {
	    staticClass: "iconfont icon-error",
	    on: {
	      "click": function($event) {
	        _vm.closeSuspension()
	      }
	    }
	  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
	    staticClass: "btn footer-suspension-btn relative",
	    class: [_vm.addVertical]
	  }, [_vm._v("\n\t\t\t\t打开小程序\n\t\t\t\t"), _c('a', {
	    staticClass: "jump-warp",
	    attrs: {
	      "href": "/user/resources.html"
	    }
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "jump-rj-title box"
	  }, [_c('li', {
	    staticClass: "jump-rj-title-item jump-rj-title-left"
	  }, [_c('span', {
	    staticClass: "border-ri"
	  }, [_vm._v("轻松掌管帐号")])]), _vm._v(" "), _c('li', {
	    staticClass: "jump-rj-title-item"
	  }, [_vm._v("便捷管理资源")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer-icp"
	  }, [_vm._v("\n\t\t©2019 睿江云版本所有证"), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "http://beian.miit.gov.cn/"
	    }
	  }, [_vm._v("粤ICP备09026812号")]), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060402000908"
	    }
	  }, [_vm._v("粤公网安备44060402000908号")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer-suspension-phone"
	  }, [_c('a', {
	    attrs: {
	      "href": "tel:4000662212"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(21),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "phone-animate"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "footer-suspension-content box"
	  }, [_c('img', {
	    staticClass: "footer-suspension-img",
	    attrs: {
	      "src": __webpack_require__(20),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('ul', [_c('li', {
	    staticClass: "footer-suspension-title"
	  }, [_vm._v("睿江云小程序")]), _vm._v(" "), _c('li', {
	    staticClass: "footer-suspension-tips"
	  }, [_vm._v("轻松掌控账号，便捷管理资源")])])])
	}]}

/***/ }),

/***/ 31:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// static/js/solve/app.c6983e18f56d86c6b0c1.js